$('.block--faq__items__item__title__button').on('click keyup', function (event) {
  if (event.type === 'click' || (event.type === 'keyup' && (event.keyCode === 13 || event.which === 13))) {
    const el = $(this);
    const parent = el.closest('.block--faq__items__item'); // Check parent container

    // Toggle the clicked item
    el.toggleClass('active').attr('aria-expanded', el.attr('aria-expanded') === 'true' ? 'false' : 'true');
    parent.find('.block--faq__items__item__content').slideToggle().attr('aria-hidden', function (index, attr) {
      return attr === 'true' ? 'false' : 'true';
    });

    // Close other items
    $('.block--faq__items__item').not(parent).find('.block--faq__items__item__title__button')
      .removeClass('active')
      .attr('aria-expanded', 'false');
    $('.block--faq__items__item').not(parent).find('.block--faq__items__item__content')
      .slideUp()
      .attr('aria-hidden', 'true');
  }
});
